import makerjs, {IModel} from "makerjs";
import AbstractShape from "@/Models/Shapes/AbstractShape";
import ShapeConfigurationFactory from "@/Models/ShapeConfigurations/ShapeConfigurationFactory";
import { convertUnits } from "@/functions/numbers";
import { Text } from "@/Models/Shapes/Text";
import { CutoutTypes } from "@/Models/CutoutTypes";
import isEmpty from "lodash/isEmpty";

const fallbackModel = new makerjs.models.Rectangle( 1, 1 );

export default {
	namespaced: true,
	state: (): object => ( {
		textModel: fallbackModel,
		textShapeInstance: null,
		defaultSize: '20',
	} ),
	getters: {
		textModel: ( state ): IModel => state.textModel,
		getTextShapeInstance: ( state ): AbstractShape|null => state.textShapeInstance,
		getInstance: ( state, getters, rootState, rootGetters ): Text => {
			const { shapeInstance, measurements } = rootGetters;

			return shapeInstance( 'text', measurements );
		},
		cutoutPrimitives: ( state, getters, rootState, { cutoutMeasurements } ): object => {
			return convertUnits( cutoutMeasurements.dimensions[ 'text' ] );
		},
		isCenteredShape: (): boolean => true,
		getArea: ( state, getters, rootState, { getArea, parsedDimensions } ): object => {
			return getArea( 'text', parsedDimensions );
		},
	},
	actions: {
		async setDefaults( { state, rootState, getters, commit, rootGetters }, isCutout = false ): Promise<void> {
			if ( ! isCutout ) {
				rootState.cutout.cutoutType = CutoutTypes.none;
			}

			let instance = getters.getInstance;
			let defaultModifiers = instance.getDefaultModifiers();
			let defaultDimensions = instance.getDefaultDimensions();

			if ( isCutout ) {
				instance = rootGetters.shapeInstance('text', getters.cutoutMeasurements );
				defaultModifiers = instance.getDefaultCutoutModifiers();
				defaultDimensions = instance.getDefaultCutoutDimensions(rootGetters.baseShapeInstance);
			}

			commit( 'updateLoadingState', true, { root: true } );

			const measurements = isCutout ? rootGetters.cutoutMeasurements : rootState.measurements;

			for (const [modifier, value] of Object.entries( defaultModifiers )) {
				if ( isEmpty( measurements.modifiers[ modifier ] ) ) {
					commit( isCutout ? "updateCutoutModifier" : "updateModifier", { modifier, value }, { root: true } );
				}
			}

			const { desired_length = state.defaultSize } = defaultDimensions;

			// isCutout here needs to be added here as it otherwise remains empty. Needs checking.
			if ( isEmpty( desired_length ) || isCutout ) {
				commit( isCutout ? 'setCutoutDimensionsForShape' : 'setDimensionsForShape', { shape: 'text', dimensions: { desired_length } }, { root: true } );
			}

			commit( 'updateLoadingState', false, { root: true } );
		},
	},
};
